import { Col, List, Row } from "antd";
import { InputField, Panel, TextComponent } from "../../../components";
import styles from "./SongIdeas.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { PdfIcon } from "../../../components/icons/Icons";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PlanningTemplatesMiddleware } from "../../../Store/Middlewares/PlanningTemplatesMiddleware";
import { BiChevronDown, BiChevronUp } from "react-icons/bi";
import { FaCheckSquare, FaRegSquare } from "react-icons/fa";
import { IoIosRadioButtonOff, IoIosRadioButtonOn } from "react-icons/io";
import { BoxTabs } from "../../../components/AntdTab/AntdTab";
import MyPlaylist from "./MyPlaylist/MyPlaylist";
import PublicPlaylist from "./PublicPlaylist/PublicPlaylist";

const SongIdeas = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const dispatch = useDispatch();

  const items = [
    {
      key: "1",
      label: "My Playlist",
      headerTitle: "Playlist",
      children: <MyPlaylist 
      />,
    },
    {
      key: "2",
      label: "Public Playlist",
      headerTitle: "Playlist",
      children: <PublicPlaylist 
      />,
    },
  ];

  // useEffect(() => {
  //   dispatch(
  //     PlanningTemplatesMiddleware.getViewResult({
  //       temp_id: temp_id,
  //       event_id: EventDetails?.id,
  //       parent_id: parent_id,
  //     })
  //   );
  // }, []);



  return (
    <>
      <BoxTabs items={items} changeHeaderOnTab={true} />
    </>
  );
};

export default SongIdeas;
